import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import car from '../cars/car.png';
import cargo from '../cars/cargo.png';
import mot from '../cars/mot.png';
import mop from '../cars/mop.png';
import quadr from '../cars/quadr.png';
import UnderButtonNav from '../components/UnderButtonNav.jsx';

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [courseImages, setCourseImages] = useState({});

  useEffect(() => {
    fetch('/api/courses')
      .then(res => {
        if (!res.ok) throw new Error('Ошибка загрузки');
        return res.json();
      })
      .then(async (data) => {
        setCourses(data);
        
        // Динамически импортируем изображения курсов
        const images = {};
        for (const course of data) {
          if (course.imageUrl) {
            const fileName = course.imageUrl.split('/').pop(); // получаем "course_123456789.jpg"
            try {
              // Пытаемся импортировать изображение
              const imageModule = await import(`../cars/${fileName}`);
              images[course.id] = imageModule.default;
            } catch (err) {
              console.log(`Изображение для курса ${course.id} не найдено`);
              images[course.id] = null;
            }
          }
        }
        setCourseImages(images);
      })
      .catch(err => console.error('Ошибка загрузки курсов:', err));
  }, []);

  const getIcon = (type) => {
    switch (type) {
      case 'B': return car;
      case 'C': return cargo;
      case 'A': return mot;
      case 'M': return [mop, quadr];
      default: return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#1b1b1b] text-[#dedede] font-['Inter',sans-serif] antialiased overflow-x-hidden">
      <Header />

      <section className="py-24 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-6 sm:px-8">
          <div className="mb-16 sm:mb-20 text-center">
            <span className="text-[13px] font-black uppercase tracking-[0.3em] text-primary">Курсы</span>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tighter mt-2">
              Наши курсы
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
            {courses.map((course) => {
              const icons = getIcon(course.type);
              const courseImage = courseImages[course.id];
              
              return (
                <div key={course.id} className="glass-card rounded-[28px] overflow-hidden hover:translate-y-[-8px] transition-all flex flex-col h-full">
                  <img 
                    src={courseImage || 'https://images.pexels.com/photos/3952053/pexels-photo-3952053.jpeg'} 
                    alt={course.title} 
                    className="w-full h-56 sm:h-64 object-cover" 
                  />
                  <div className="p-6 sm:p-8 flex flex-col flex-grow">
                    <h3 className="text-xl sm:text-2xl font-black uppercase tracking-tight mb-6">
                      {course.title}
                    </h3>

                    <div className="mt-auto flex items-center justify-between gap-4">
                      <div className="text-3xl sm:text-4xl font-black text-primary whitespace-nowrap flex-shrink-0 min-w-0">
                        {course.price}
                      </div>

                      <div className="flex items-center gap-3 sm:gap-4">
                        {Array.isArray(icons) ? (
                          <>
                            <img src={icons[0]} alt="Мопед" className="w-16 h-16 sm:w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain opacity-90 drop-shadow-lg flex-shrink-0" />
                            <img src={icons[1]} alt="Квадроцикл" className="block lg:hidden w-16 h-16 sm:w-20 h-20 md:w-24 md:h-24 object-contain opacity-90 drop-shadow-lg flex-shrink-0" />
                          </>
                        ) : (
                          icons && <img src={icons} alt={course.type} className="w-16 h-16 sm:w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain opacity-90 drop-shadow-lg flex-shrink-0" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <BottomNav />
      <UnderButtonNav />
    </div>
  );
}